import * as c from "react";
const e = (l) => /* @__PURE__ */ c.createElement(
  "svg",
  {
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ c.createElement(
    "path",
    {
      d: "M10.955 1.096C10.495.636 10.168.5 9.517.5H1.263C.356.5 0 .856 0 1.763v16.474c0 .907.356 1.263 1.263 1.263H14.57c.907 0 1.263-.356 1.263-1.263V6.816c0-.651-.135-.977-.595-1.438l-4.283-4.282zm3.774 16.962c0 .242-.096.337-.337.337H1.442c-.242 0-.337-.095-.337-.337v-4.087h13.623v4.087zM5.244 12.32c.251 0 .53-.054.694-.12l.126.65c-.153.077-.498.16-.946.16-1.273 0-1.93-.793-1.93-1.843 0-1.258.897-1.958 2.012-1.958.432 0 .76.088.908.164l-.17.662a1.801 1.801 0 00-.7-.137c-.66 0-1.175.4-1.175 1.22 0 .738.437 1.202 1.181 1.202zm2.285-.913c-.612-.213-1.012-.552-1.012-1.088 0-.629.525-1.11 1.395-1.11.415 0 .721.088.94.186l-.185.673a1.755 1.755 0 00-.771-.175c-.361 0-.536.164-.536.355 0 .235.208.34.683.52.651.24.957.58.957 1.099 0 .617-.475 1.142-1.487 1.142-.421 0-.837-.11-1.044-.224l.17-.689c.223.115.567.23.923.23.383 0 .585-.159.585-.4 0-.229-.175-.36-.618-.519zM9.25 9.27h.913l.448 1.558c.126.437.24.858.328 1.318h.017c.092-.443.207-.88.333-1.302l.47-1.574h.886l-1.241 3.685h-.974l-1.18-3.685zm5.478-1.024H1.106V1.942c0-.242.095-.337.336-.337h8.412c.121 0 .169.048.169.168v3.275c0 .907.356 1.263 1.263 1.263h3.274c.121 0 .169.048.169.169v1.765z",
      fill: "#2d6ded"
    }
  )
);
export {
  e as default
};
